module.exports = __webpack_public_path__ + "img/group.0feb4932.png";